import {
  Archive,
  CircleHelp,
  FileText,
  Gavel,
  Hourglass,
  Inbox,
  Search,
  Send,
  Settings,
  Sparkles,
  Trash2,
  type LucideIcon,
} from 'lucide-react';

// Ícones dos estados (campo `icone` do banco) para componentes Lucide.
const ICONES: Record<string, LucideIcon> = {
  sparkles: Sparkles,
  search: Search,
  'file-text': FileText,
  send: Send,
  gavel: Gavel,
  hourglass: Hourglass,
  settings: Settings,
  inbox: Inbox,
  archive: Archive,
  'trash-2': Trash2,
};

export function IconeEstado({ nome, tamanho = 22 }: { nome: string; tamanho?: number }) {
  const Icone = ICONES[nome] ?? CircleHelp;
  return <Icone size={tamanho} strokeWidth={2.2} aria-hidden />;
}
